import React from 'react';
import { Input, Button, Space } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';

const state = {
  searchInput: null,
  searchText: '',
  searchedColumn: '',
};

const handleReset = (clearFilters: () => void) => {
  state.searchedColumn = '';
  state.searchText = '';
  clearFilters();
};

const handleSearch = (
  value: string[],
  confirm: (arg0: { closeDropdown: boolean }) => void,
  dataIndex: string,
  setSearchedColumn: (arg0: any) => void
) => {
  setSearchedColumn(dataIndex);
  state.searchText = value[0];
  state.searchedColumn = dataIndex;
  confirm({
    closeDropdown: false,
  });
};

const getColumnSearchProps = (
  dataIndex: string,
  placeholder: string,
  searchText: string,
  resetText: string,
  searchedColumn: string,
  setSearchedColumn: (value: ((prevState: string) => string) | string) => void,
  resetFunction?: () => void
): {
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }: {
    setSelectedKeys: any;
    selectedKeys: any;
    confirm: any;
    clearFilters: any;
  }) => JSX.Element;
  onFilter: (value: any, record: any) => boolean | string;
  onFilterDropdownVisibleChange: (visible: boolean) => void;
  render: (text: { toString: () => string }) => JSX.Element;
} => ({
  onFilter: (value, record) =>
    record[dataIndex]
      ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
      : '',
  onFilterDropdownVisibleChange: (visible) => {
    if (visible) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setTimeout(() => state.searchInput.select(), 100);
    }
  },
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <div
      style={{
        padding: 8,
      }}
    >
      <Input
        ref={(node) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          state.searchInput = node;
        }}
        placeholder={placeholder}
        value={state.searchText}
        onChange={(e) => {
          setSelectedKeys(e.target.value ? [e.target.value] : []);
          state.searchText = e.target.value;
        }}
        onPressEnter={() =>
          handleSearch(selectedKeys, confirm, dataIndex, setSearchedColumn)
        }
        style={{
          width: 188,
          marginBottom: 8,
          display: 'block',
        }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() =>
            handleSearch(selectedKeys, confirm, dataIndex, setSearchedColumn)
          }
          icon={<SearchOutlined />}
          size="small"
          style={{
            width: 90,
          }}
        >
          {searchText}
        </Button>
        <Button
          onClick={() => {
            if (resetFunction) {
              resetFunction();
            } else {
              setSearchedColumn(dataIndex);
              handleReset(clearFilters);
            }
          }}
          size="small"
          style={{
            width: 90,
          }}
        >
          {resetText}
        </Button>
      </Space>
    </div>
  ),
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  render: (text: { toString: () => string }) => {
    if (searchedColumn === dataIndex) {
      return (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      );
    }
    return text;
  },
});

export default getColumnSearchProps;
